import {h} from 'preact'
import {PureComponent} from 'preact-compat'

import {SkilljarHit} from '../algolia/components'
import SkilljarResults from './SkilljarResults'

interface Props {
  hits: Array<SkilljarHit>
  pageCount: number,
  clickCallback: (hit: SkilljarHit, idx: number) => void
}

interface State {
  hits: Array<SkilljarHit>,
}

export default class extends PureComponent<Props, State> {
  constructor () {
    super()
    this.state = {
      hits: []
    }
  }

  updateList () {
    let joinWith: State['hits'] = []
    if (this.props.pageCount > 0) {
      joinWith = this.state.hits
    }

    this.setState({
      hits: joinWith.concat(this.props.hits)
    })
  }

  componentDidMount () {
    this.updateList()
  }

  componentDidUpdate (prevProps: Props) {
    if (JSON.stringify(this.props.hits) === JSON.stringify(prevProps.hits)) return

    this.updateList()
  }

  render ({ clickCallback} : Props) {
    return <div> {
      this.state.hits.map((hit, idx) => {
        return <SkilljarResults clickCallback={() => clickCallback(hit, idx)} hit={hit} />
      })
    }</div>
  }
}

